import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { LanguageProvider } from './contexts/LanguageContext'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import LandingPage from './pages/LandingPage'
import Login from './pages/Login'
import Users from './pages/Users'
import WarehouseIndex from './pages/warehouse'
import AddCarPage from './pages/warehouse/add-car'
import SellCar from './pages/SellCar'
import SellCarHistory from './pages/SellCarHistory'
import CarDetails from './pages/CarDetails'
import EditCar from './pages/EditCar'
import ExchangeCarsIndex from './pages/exchange-cars'
import AddExchangePage from './pages/exchange-cars/add-exchange'
import ExchangeCarDetail from './pages/exchange-cars/exchange-detail'
import EditExchangePage from './pages/exchange-cars/edit-exchange'
import Settings from './pages/Settings'
import Help from './pages/Help'
import CarBrandsSettings from './pages/settings/CarBrandsSettings'
import CarModelsSettings from './pages/settings/CarModelsSettings'
import SellersSettings from './pages/settings/SellersSettings'
import LanguageSettings from './pages/settings/LanguageSettings'
import InvoiceThemeSettings from './pages/settings/InvoiceThemeSettings'
import DatabaseBackupSettings from './pages/settings/DatabaseBackupSettings'
import BuyersSettings from './pages/settings/BuyersSettings'
import ExpensesIndex from './pages/expenses/index'
import AddExpensePage from './pages/expenses/add-expense'
import EditExpensePage from './pages/expenses/edit-expense'
import ExpenseCategoryPage from './pages/expenses/expense-category'
import Report from './pages/Report'
import AgreementsIndex from './pages/agreements'
import AddAgreementPage from './pages/agreements/add-agreement'
import CurrencyExchange from './pages/CurrencyExchange'
import CarsOfDaraPage from './pages/cars-of-dara'
import CarsOfDaraListPage from './pages/cars-of-dara/list'
import EditCarsOfDaraPage from './pages/cars-of-dara/edit'
import Layout from './components/Layout'
import { Toaster } from './components/ui/sonner'

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </LanguageProvider>
  );
}

function AppRoutes() {
  const location = useLocation();
  const currentPage = location.pathname.substring(1) || 'sell-car'; // Remove leading slash

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/users" element={
        <ProtectedRoute>
          <Layout currentPage="users">
            <Users />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/warehouse" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <WarehouseIndex />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/warehouse/add-car" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <AddCarPage />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/sell-car" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <SellCar />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/sell-car-history" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <SellCarHistory />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/exchange-cars" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <ExchangeCarsIndex />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/exchange-cars/add" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <AddExchangePage />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/exchange-cars/:id/edit" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <EditExchangePage />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/exchange-cars/:id" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <ExchangeCarDetail />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/sell-car-history/:carId" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <CarDetails />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/edit-car/:carId" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <EditCar />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/expenses" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <ExpensesIndex />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/expenses/add-expense" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <AddExpensePage />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/expenses/edit-expense/:id" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <EditExpensePage />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/expenses/expense-category" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <ExpenseCategoryPage />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/agreements" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <AgreementsIndex />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/agreements/add" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <AddAgreementPage />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/report" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <Report />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <Settings />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/help" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <Help />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/currency-exchange" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <CurrencyExchange />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/cars-of-dara" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <CarsOfDaraPage />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/cars-of-dara/list" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <CarsOfDaraListPage />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/cars-of-dara/:id/edit" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <EditCarsOfDaraPage />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/settings/car-brands" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <CarBrandsSettings />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/settings/car-models" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <CarModelsSettings />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/settings/sellers" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <SellersSettings />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/settings/buyers" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <BuyersSettings />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/settings/language" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <LanguageSettings />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/settings/invoice-theme" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <InvoiceThemeSettings />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/settings/database-backup" element={
        <ProtectedRoute>
          <Layout currentPage={currentPage}>
            <DatabaseBackupSettings />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App
